import { profileStore } from "./profileStore";
import { domainStore } from "./domainStore";

export function resetUserScopedState() {
  // Reset all module-level stores and timers
  profileStore.resetAll();
  domainStore.resetUserScopedState();

  // Clear all user-specific storage keys
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("access_token");
    localStorage.removeItem("role");
    localStorage.removeItem("user_data");
    localStorage.removeItem("has_visited_reports");
    localStorage.removeItem("threatactix_recent_searches");
    localStorage.removeItem("reports_clicked");
  }
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem("last_searched_domain");
  }
}
